import { render, staticRenderFns } from "./OrphanFlux.vue?vue&type=template&id=bbe151fc&"
import script from "./OrphanFlux.vue?vue&type=script&lang=js&"
export * from "./OrphanFlux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports